'use strict';
(function ($) {
    var $formElement = $('#jwsdw-nlsignup-form'),
        xhr;

    $.validator.setDefaults({
        'groups': {
            'date': 'dateOfBirthDay dateOfBirthMonth dateOfBirthYear'
        },
        'rules': {
            'email': {
                'invalidvalue': true,
                'customemail': true
            },
            'dateOfBirth': {
                'checkDate': '#jwsdw-newsletter-dateOfBirth'
            }
        }
    });

    $formElement.validate();

    $formElement.on('submit', function(e) {
        var $form = $(this),
            $captcha = $form.find('.g-recaptcha'),
            $submitButton = $form.find('#jwsdw-newsletter-submit');

        e.preventDefault();

        // only submit form if frontend validation is successful and no other call is executed
        if (!$form.valid() || (xhr && xhr.readyState !== 4)) {
            return;
        }

        if (window.jwsdwRecaptchaSettings.captchaDisabled === false) {
            window.grecaptcha.ready(function() {
                window.jwsdwUtil.captcha.execute($captcha.attr('id'), 'newsletter').then(submitFormHandler);
            });
        } else {
            submitFormHandler();
        }

        /**
         * @description Method to trigger submit again when form is valid
         * @returns {void}
         */
        function submitFormHandler() {
            var $err = $form.find('.jwsdw-newsletter-error');

            $submitButton.find('.jwsdw-buttonText').addClass('jwsdw-invisible');
            $submitButton.find('.jwsdw-spinner').removeClass('jws-hidden');
            $submitButton.attr('disabled', 'disabled');

            xhr = $.ajax(asURLEncoded($form))
                .done(function(response) {
                    $('.jwsdw-nlsignup-wrapper').html(response);
                    if (/jwsdw-nlsignup-success/.test(response)) {
                        window.jwsdwApi.tracking.fireEvent('newsletter', {
                            'type': 'newsletterSubscriptionSuccessful'
                        });
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'ce.misc',
                            'eventCategory': 'Misc',
                            'eventAction': 'Newsletter',
                            'eventLabel': 'signup',
                            'eventValue': undefined,
                            'nonInteraction': false
                        });
                    }
                }).fail(function(response) {
                    var message = window.app.resources.SERVER_CONNECTION_ERROR;
                    if (response.responseJSON) {
                        message = response.responseJSON.details.message;
                    }
                    $err.text(message).removeClass('jws-hidden');
                }).always(function() {
                    $submitButton.find('.jwsdw-buttonText').removeClass('jwsdw-invisible');
                    $submitButton.find('.jwsdw-spinner').addClass('jws-hidden');
                    $submitButton.removeAttr('disabled');
                });
        }

        /**
         * Method generate settings object for ajax requests
         * @param {String|object} form selector element to pass to jQuery
         * @returns {Object} ajax paremeters
         */
        function asURLEncoded(form) {
            form = $(form);
            return {
                'contentType': 'application/x-www-form-urlencoded; charset=UTF-8',
                'type': form.attr('method'),
                'url': form.attr('action'),
                'data': form.serialize()
            };
        }
    });
}(jQuery));
